import { render, staticRenderFns } from "./situazione.vue?vue&type=template&id=9bfd1868&scoped=true&lang=html"
import script from "./situazione.vue?vue&type=script&lang=js"
export * from "./situazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfd1868",
  null
  
)

export default component.exports